export default __webpack_public_path__ + "static/media/left-arrow.4121176e.svg";